module.exports = __webpack_public_path__ + "media/images/admin/icon/icon_lock-38b6120cbdcfecd8104aa4dfa2f8b332.svg";